import React from 'react';
import { FaGraduationCap, FaHandsHelping, FaClipboardList, FaSearch, FaAppleAlt, FaHeart } from 'react-icons/fa';

const WhyChooseMe = () => {
  const reasons = [
    {
      icon: <FaGraduationCap className="h-8 w-8 text-secondary" />,
      title: "Expertise in Nutrition",
      description: "With a Bachelor's degree in Food, Nutrition, and Dietetics, I provide reliable and evidence-based information in every article."
    },
    {
      icon: <FaHandsHelping className="h-8 w-8 text-secondary" />,
      title: "Tailored Guidance",
      description: "My experience in managing chronic conditions allows me to offer personalized advice that meets diverse nutritional needs."
    },
    {
      icon: <FaClipboardList className="h-8 w-8 text-secondary" />,
      title: "Actionable Strategies",
      description: "I deliver practical strategies for improving health that can easily be incorporated into daily routines."
    },
    {
      icon: <FaSearch className="h-8 w-8 text-secondary" />,
      title: "Current Trends",
      description: "I stay updated with the latest trends and advancements in nutrition to provide you with the most relevant information."
    },
    {
      icon: <FaAppleAlt className="h-8 w-8 text-secondary" />,
      title: "Healthy Recipes",
      description: "I share innovative and delicious recipes that make healthy eating enjoyable and accessible."
    },
    {
      icon: <FaHeart className="h-8 w-8 text-secondary" />,
      title: "Passion for Nutrition",
      description: "My genuine passion for nutrition drives me to continuously learn and share valuable insights with my readers."
    },
  ];

  return (
    <div className="py-10 bg-white">
      <h1 className="text-center text-4xl font-bold mb-8 text-secondary font-poppins">Why Choose My Blog?</h1>
      <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 px-4">
        {reasons.map((reason, index) => (
          <div key={index} className="bg-white border border-gray-200 rounded-lg shadow-lg p-6 flex flex-col items-center transition-transform duration-300 hover:scale-105">
            <div className="mb-4">
              {reason.icon}
            </div>
            <h2 className="text-xl font-semibold mb-2 text-secondary font-poppins">{reason.title}</h2>
            <p className=" text-[#626262] font-poppins text-start">{reason.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhyChooseMe;

